import React from 'react';
import { MetricDataSet } from './MetricsDisplay';

interface IncidentSummaryProps {
  currentDataSet: MetricDataSet;
}

const IncidentSummary: React.FC<IncidentSummaryProps> = ({ currentDataSet }) => {
  const openIncidents = currentDataSet.acknowledged.current + currentDataSet.triggered.current;
  const totalIncidents =
    openIncidents + currentDataSet.resolved.current + currentDataSet.suppressed.current;

  return (
    <div style={{ top: 10 }}>
      <p className="item-box-main-heading" style={{ margin: 0, fontSize: 20 }}>
        {openIncidents} Open Incident{openIncidents > 1 ? 's' : ''}
      </p>
      <p
        style={{
          margin: 0,
          marginTop: 10,
          fontWeight: 600,
          fontSize: 14,
          color: '#8690A4',
        }}
      >
        Out of {totalIncidents} total incidents
      </p>
    </div>
  );
};

export default IncidentSummary;
